import React, { useState, useEffect, Fragment } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, InputGroup, InputGroupAddon, InputGroupText, Container, ListGroup, ListGroupItem, ListGroupItemHeading, Progress } from 'reactstrap';
import { Prompt, NavLink as RouterNavLink, Link } from 'react-router-dom';
// @ts-ignore
import Select from 'react-select';
// @ts-ignore
import randomstring from "randomstring";
import BlobUtil from '../../utils/blobUtil';
// @ts-ignore
import DatePicker from 'reactstrap-date-picker';
import CreatableSelect from 'react-select/creatable';
// @ts-ignore
import countryList from 'react-select-country-list'

export default function DetailForm({props, read, save, remove, 
    overwriteWarningFlag, overwriteHandleWarning, isNew, positionList}: any) {
  
  const [overwriteFlag, setOverwriteFlag] = useState("false");
  const [removeWarning, setRemoveWarning] = useState(false);
  const toggleRemoveWarning = () => setRemoveWarning(!removeWarning);

  const [eTag, setETag] = useState(""); // Detect changes on data
  const [isSaved, setIsSaved] = useState(false);

  const [ _startDate, setStartDate ] = useState(props.data?.startDate);
  const [ _endDate, setEndDate ] = useState(props.data?.endDate);
  const [ _discType, setDiscType ] = useState(props.data?.discType);

  const { register, handleSubmit, reset, watch, errors, formState, control  } = useForm();

  const organiserCategory: any = [];
  props.dataOrganiser?.map(function (elem: any) {
    organiserCategory.push({ value: elem.orgName, label: elem.orgName });
  });

  const courseOptionsList: any = [];
  props.data?.ruleLimitCourse?.map((s:string)=>{
    courseOptionsList.push({value:s, label:s});
  })

  // Read the formState before render to subscribe the form state through Proxy
  const { dirty, isSubmitting, isSubmitted, touched, submitCount } = formState;
  
  const onSubmit = (data : any, e: any) => {
    //console.log(data)
    save(data);
    setIsSaved(true);
  };

  const watchFields = watch(["_etag"]);
  if (watchFields){
      if (watchFields._etag !== undefined && props.data?._etag !== undefined && (eTag === "" || eTag != props.data?._etag)){
        setETag(props.data._etag);
        //console.log("_etag updated..." + props.data._etag);
        if (isSaved){ // Reset only if record updated and issubmitted
            //console.log("Call Reset");
            setTimeout(() => {
                reset();
                setIsSaved(false);
            }, 0)
            
        }
      }
  }

  const handleRequestDelete = () => {
    remove(props.data);
    setRemoveWarning(!removeWarning);
  }
  
  const handleReloadData = () => {
    read();
    overwriteHandleWarning();
  }
  
  const handleStartDate = (e: any) => {
    setStartDate(e[0]);
    return e[0];
  }
  const handleEndDate = (e: any) => {
    setEndDate(e[0]);
    return e[0];
  }
  const handleDiscType = (e: any) => {
    //console.log(e.target.value);
    setDiscType(e.target.value);
    return e.target.value;
  }
  
  const _professionalCategory = [
    { value: 'Accountancy', label: 'Accountancy' },
    { value: 'Company Secretary', label: 'Company Secretary' },
    { value: 'Tax Agent', label: 'Tax Agent' },
    { value: 'Contractor', label: 'Contractor' },
    { value: 'Engineering', label: 'Engineering' },
    { value: 'Project Management', label: 'Project Management' },
    { value: 'Arts & Culture', label: 'Arts & Culture' },
    { value: 'MBOT', label: 'MBOT' }
  ];
  
  const _countryOptions = countryList().getData();

  const handleMultiSelectedOption = (optionList: any, name: any) => {
    let arr: any = [];
    if (name){
        name.forEach((element:any) => {
            let index = optionList.map(function(e: any) { 
                return e.label; 
            }).indexOf(element);
    
            if (index !== -1) {
                arr.push(optionList[index]);
            }
            else {
                optionList.push({value: element, label: element});
                let index1 = optionList.map(function(e: any) { 
                    return e.label; 
                }).indexOf(element);
                arr.push(optionList[index1]);
            }
        });
    }

    return arr;
  }

  return (
      <Fragment>
        <Form id='DetailsFrom' className="mt-12 mb-12" onSubmit={handleSubmit(onSubmit)}>
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Promo Settings</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="promoCode" sm={3}>Promo Code</Label >
                            <Col lg={3} sm={3}>
                                <Input type="text" name="promoCode" defaultValue={props.data?.promoCode}
                                    innerRef={register({ required: true, minLength:3, maxLength:10 })} />
                                {errors.promoCode && <FormText color="danger">Required field. Maximum length 10 character.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="description" sm={3}>Description</Label >
                            <Col lg={6} sm={6}>
                                <Input type="text" name="description" defaultValue={props.data?.description}
                                    innerRef={register({ required: true, minLength:10 })} />
                                {errors.description && <FormText color="danger">Required field. Minimum length 10 character.</FormText>}
                            </Col>
                        </FormGroup>
                        
                        <FormGroup row={true}>
                            <Label for="discType" sm={3}>Discount By</Label >
                            {/* {JSON.stringify(props.data?.discType)} */}
                            <Col lg={1} sm={1}>
                                <Label check>
                                    <Input type="radio" name="discType" innerRef={register} value="Amount" onChange={handleDiscType} checked={_discType === "Amount"}/>{' '}Amount
                                </Label>
                            </Col>
                            <Col lg={3} sm={3}>
                                <InputGroup>
                                    {/* <InputGroupAddon addonType="prepend">
                                        <InputGroupText>RM</InputGroupText>
                                    </InputGroupAddon> */}
                                    <Input type="number" name="discAmount" step="any" placeholder="Discount Amount" 
                                            defaultValue={props.data?.discAmount} style={{textAlign:"right"}} 
                                            disabled={_discType === "Percentage"}
                                            innerRef={register} />
                                </InputGroup>
                            </Col>
                            <Col lg={1} sm={1}>
                                <Label check>
                                    <Input type="radio" name="discType" innerRef={register} value="Percentage" onChange={handleDiscType} checked={_discType === "Percentage"}/>{' '}Percentage
                                </Label>
                            </Col>
                            <Col lg={2} sm={2}>
                                <InputGroup>
                                    <Input type="number" name="discPct" placeholder="%" 
                                            defaultValue={props.data?.discPct} 
                                            style={{textAlign:"right"}} 
                                            onKeyDown={e => /[\+\-\.\,]$/.test(e.key) && e.preventDefault()}
                                            disabled={_discType === "Amount"}
                                            innerRef={register} />
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText>%</InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Rules</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="startDate" sm={3}>Valid from</Label >
                            <Col lg={2} sm={2}>
                                <Controller
                                    as={<DatePicker />}
                                    control={control}
                                    name="startDate"
                                    defaultValue={_startDate}
                                    onChange={handleStartDate}
                                    dateFormat={"DD/MM/YYYY"}
                                    showClearButton={false}
                                />
                            </Col>
                            <Col lg={1} sm={1}>
                                <span>to</span>
                            </Col>
                            <Col lg={2} sm={2}>
                                <Controller
                                    as={<DatePicker />}
                                    control={control}
                                    name="endDate"
                                    defaultValue={_endDate}
                                    onChange={handleEndDate}
                                    dateFormat={"DD/MM/YYYY"}
                                    showClearButton={false}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="ruleAmtFrom" sm={3}>Discounted Amount From</Label >
                            <Col lg={3} sm={3}>
                                <InputGroup>
                                    {/* <InputGroupAddon addonType="prepend">
                                        <InputGroupText>RM</InputGroupText>
                                    </InputGroupAddon> */}
                                    <Input type="number" name="ruleAmtFrom" step="any" placeholder="Amount" 
                                            defaultValue={props.data?.ruleAmtFrom} style={{textAlign:"right"}} 
                                            innerRef={register} />
                                </InputGroup>
                            </Col>
                            <Col lg={1} sm={1}>to</Col>
                            <Col lg={3} sm={3}>
                                <InputGroup>
                                    {/* <InputGroupAddon addonType="prepend">
                                        <InputGroupText>RM</InputGroupText>
                                    </InputGroupAddon> */}
                                    <Input type="number" name="ruleAmtTo" step="any" placeholder="Amount" 
                                            defaultValue={props.data?.ruleAmtTo} style={{textAlign:"right"}} 
                                            innerRef={register} />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="ruleLimitCourse" lg={3} sm={2}>Course (Course Id)</Label >
                            <Col lg={9} sm={10}>
                                <Controller
                                    as={<CreatableSelect />}
                                    control={control} 
                                    name="ruleLimitCourse"
                                    defaultValue={courseOptionsList}
                                    isMulti={true}
                                    isClearable={true}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="ruleLimitProfession" lg={3} sm={2}>Professional</Label >
                            <Col lg={9} sm={10}>
                                <Controller 
                                    as={Select}
                                    name="ruleLimitProfession"
                                    options={_professionalCategory}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(_professionalCategory, props.data?.ruleLimitProfession)}
                                />
                                {errors.ruleLimitProfession && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="ruleLimitOrganizer" lg={3} sm={2}>Organiser</Label >
                            <Col lg={9} sm={10}>
                                <Controller 
                                    as={Select}
                                    name="ruleLimitOrganizer"
                                    options={organiserCategory}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(organiserCategory, props.data?.ruleLimitOrganizer)}
                                />
                                {errors.ruleLimitOrganizer && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="ruleLimitCountry" lg={3} sm={2}>Country</Label >
                            <Col lg={9} sm={10}>
                                <Controller
                                    as={Select}
                                    name="ruleLimitCountry"
                                    options={_countryOptions}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(_countryOptions, props.data?.ruleLimitCountry)}
                                />
                                {errors.ruleLimitCountry && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="ruleLimitUse" sm={3}>Limited Number of times use</Label >
                            <Col lg={2} sm={2}>
                                <Input type="number" name="ruleLimitUse" step="any" placeholder="" 
                                onKeyDown={e => /[\+\-\.\,]$/.test(e.key) && e.preventDefault()}
                                defaultValue={props.data?.ruleLimitUse} style={{textAlign:"right"}} 
                                innerRef={register} />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="singleUserPerUser" sm={3}>Limited Single use only per User</Label >
                            <Col lg={6} sm={6}>
                                <Label>
                                    <Input type="checkbox" name="singleUserPerUser" defaultChecked={props.data?.singleUserPerUser}
                                    innerRef={register({ })} 
                                    style={{marginLeft: "10px", top: "8px"}}
                                    />{' '}
                                    <span style={{marginLeft: "28px"}}>Enable</span>
                                </Label>
                            </Col>
                        </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />

            <Input type="hidden" name="Overwrite" value={overwriteFlag} innerRef={register()} />
            <Input type="hidden" name="_etag" defaultValue={props.data?._etag}  innerRef={register()} />

            <FormGroup row={true}>
                <Col sm={12}>
                    {
                        !isNew && (
                            <Button color="danger" size="lg" className="float-left" disabled={props.ui.loading || props.ui.processing} 
                                onClick={toggleRemoveWarning}>
                                <i className="fas fa-trash-alt mr-1"></i>&nbsp;Remove
                            </Button>
                        )
                    }
                    <Button type="submit" color="primary" size="lg" className="float-right" disabled={!dirty || props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("false")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Save
                    </Button>
                    {
                        props.ui.processing && (<Spinner color="warning" className="float-right">&nbsp;</Spinner>)
                    }   
                </Col>
            </FormGroup>
            <Modal isOpen={overwriteWarningFlag} toggle={overwriteHandleWarning}>
                <ModalHeader toggle={overwriteHandleWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Record you changing is not the latest version. <br/>
                        Please confirm if you want to :- <br/>
                        1. Overwrite. Update latest data with your changes. <br/>
                        2. Reload. Discarding your current changes.<br/>
                        3. Cancel. Remain your changes.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>                 
                    <Button form="DetailsFrom" type="submit" color="warning" size="lg" className="float-right" 
                        disabled={props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("true")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Overwrite
                    </Button>
                    <Button color="danger" size="lg" onClick={handleReloadData}>
                        <i className="fas fa-redo-alt mr-1"></i>&nbsp; Reload
                    </Button>
                    <Button color="secondary" size="lg" onClick={overwriteHandleWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            
            <Modal isOpen={removeWarning} toggle={toggleRemoveWarning} >
                <ModalHeader toggle={toggleRemoveWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Please confirm to remove this record<br/>
                        Note. This action is irreversible.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <Button color="danger" size="lg" onClick={handleRequestDelete}>
                        <i className="fas fa-trash-alt mr-1"></i>&nbsp; Proceed to Remove
                    </Button>
                    <Button color="secondary" size="lg" onClick={toggleRemoveWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            <Modal isOpen={props.ui.processState === 3} backdrop="static" keyboard={false} >
                <ModalHeader>Success</ModalHeader>
                <ModalBody>
                    <p>Succesfully remove!<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <RouterNavLink to="/marketings" className="nav-link" exact>
                        <i className="fas fa-list mr-1"></i>Back to Marketing List
                    </RouterNavLink>
                </ModalFooter>
            </Modal> 
        </Form>
        <br/><br/>
        <br/>
        {/* <Row>
            <Col lg="12">
                {JSON.stringify(props.data)}
            </Col>
        </Row> */}
        <Prompt when={dirty && !isSubmitted} 
            message="Are you sure want to discard your changes?"
        />
    </Fragment>
    
  );
}